export interface QuotationStep {
  id: number;
  titleKey: string;
  descKey: string;
  icon: string;
}

export const quotationSteps: QuotationStep[] = [
  {
    id: 1,
    titleKey: 'quotation.step1',
    descKey: 'quotation.step1.desc',
    icon: 'ri-search-line',
  },
  {
    id: 2,
    titleKey: 'quotation.step2',
    descKey: 'quotation.step2.desc',
    icon: 'ri-palette-line',
  },
  {
    id: 3,
    titleKey: 'quotation.step3',
    descKey: 'quotation.step3.desc',
    icon: 'ri-file-list-3-line',
  },
  {
    id: 4,
    titleKey: 'quotation.step4',
    descKey: 'quotation.step4.desc',
    icon: 'ri-checkbox-circle-line',
  },
  {
    id: 5,
    titleKey: 'quotation.step5',
    descKey: 'quotation.step5.desc',
    icon: 'ri-shopping-cart-line',
  },
  {
    id: 6,
    titleKey: 'quotation.step6',
    descKey: 'quotation.step6.desc',
    icon: 'ri-truck-line',
  },
];